<template>
  <div class="container">
    <div class="content">
      <div class="header">
        <img class="back" alt="Back button" src="~@/assets/images/back.png" @click="$router.push({ name: 'step-1' })">
        <p>Stap 2 / 3</p>
        <h1><strong>Je gegevens</strong></h1>
      </div>
      <div class="group form">

        <ck-input label="Firma naam" v-model="company_name" :haserror="errors.has('company_name')" v-validate="'required'" data-vv-name="company_name">
          Gelieve een firma naam in te vullen
        </ck-input>

       <ck-input label="Uw naam" v-model="person_name" :haserror="errors.has('person_name')" v-validate="'required'" data-vv-name="person_name">
          Gelieve een naam in te vullen
        </ck-input>

        <ck-input label="Uw e-mail" v-model="email" :haserror="errors.has('email')" v-validate="'required|email'" data-vv-name="email">
          Gelieve een geldige e-mail in te vullen
        </ck-input>

        <p>Uw gegevens wordt strikt vertrouwelijk verwerkt en enkel binnen het kader van deze actie gebruikt.</p>

        <ck-button class="small" action="Verzend" @click.native="nextStep" />

      </div>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
        nextStep() {
            this.$validator.validateAll().then(result => {
                if (result === true) {
                    this.$store.dispatch("logVisit").then(() => {
                        this.$router.push({ name: "visitor" });
                    });
                }
            });
        }
    },
    computed: {
        email: {
            get() {
                return this.$store.state.email;
            },
            set(value) {
                this.$store.commit("setEmail", value);
            }
        },
        company_name: {
            get() {
                return this.$store.state.company_name;
            },
            set(value) {
                this.$store.commit("setCompanyName", value);
            }
        },
        person_name: {
            get() {
                return this.$store.state.person_name;
            },
            set(value) {
                this.$store.commit("setPersonName", value);
            }
        }
    }
};
</script>
